// Centralized URL configuration
const API_CONFIG = {
  BASE_URL: 'http://localhost:8000/api',
  STORAGE_URL: 'http://localhost:8000/storage',
  APP_URL: 'http://localhost:8000',
};

// Environment-based configuration
const getConfig = () => {
  // Check if we're in production by looking at the current URL
  const isProduction = window.location.hostname === 'digitalawards.co.tz' || 
                       window.location.hostname === 'www.digitalawards.co.tz';
  
  if (isProduction) {
    return {
      BASE_URL: 'https://bcdlas.digitalawards.co.tz/api',
      STORAGE_URL: 'https://bcdlas.digitalawards.co.tz/storage',
      APP_URL: 'https://bcdlas.digitalawards.co.tz',
    };
  }
  
  // Development or fallback
  return API_CONFIG;
};

const config = getConfig();

export const URLS = {
  API: {
    BASE: config.BASE_URL,
    
    // Authentication endpoints
    AUTH: {
      LOGIN: `${config.BASE_URL}/auth/login`,
      REGISTER: `${config.BASE_URL}/auth/register`,
      VERIFY_EMAIL: `${config.BASE_URL}/auth/verify-email`,
      RESEND_VERIFICATION: `${config.BASE_URL}/auth/resend-verification`,
      FORGOT_PASSWORD: `${config.BASE_URL}/auth/forgot-password`,
      RESET_PASSWORD: `${config.BASE_URL}/auth/reset-password`,
      USER: `${config.BASE_URL}/auth/user`,
      LOGOUT: `${config.BASE_URL}/auth/logout`,
    },
    
    // Categories endpoints
    CATEGORIES: {
      LIST: `${config.BASE_URL}/categories`,
      BY_ID: (id: number) => `${config.BASE_URL}/categories/${id}`,
      SUBCATEGORIES: (categoryId: number) => `${config.BASE_URL}/categories/${categoryId}/subcategories`,
      YEARS: `${config.BASE_URL}/categories/years`,
    },
    
    // Winners endpoints
    WINNERS: {
      LIST: `${config.BASE_URL}/winners`,
      BY_ID: (id: number) => `${config.BASE_URL}/winners/${id}`,
      BY_YEAR: (year: string) => `${config.BASE_URL}/winners/year/${year}`,
      BY_CATEGORY: (category: string) => `${config.BASE_URL}/winners/category/${category}`,
      YEARS: `${config.BASE_URL}/winners/years`,
      CATEGORIES: `${config.BASE_URL}/winners/categories`,
      SUBCATEGORIES: `${config.BASE_URL}/winners/subcategories`,
    },
    
    // Blog endpoints
    BLOG: {
      LIST: `${config.BASE_URL}/blog`,
      BY_SLUG: (slug: string) => `${config.BASE_URL}/blog/${slug}`,
      FEATURED: `${config.BASE_URL}/blog/featured`,
      RECENT: `${config.BASE_URL}/blog/recent`,
      TAGS: `${config.BASE_URL}/blog/tags`,
      AUTHORS: `${config.BASE_URL}/blog/authors`,
    },
    
    // Admin Blog endpoints
    ADMIN_BLOG: {
      LIST: `${config.BASE_URL}/admin/blog`,
      BY_ID: (id: number) => `${config.BASE_URL}/admin/blog/${id}`,
      CREATE: `${config.BASE_URL}/admin/blog`,
      UPDATE: (id: number) => `${config.BASE_URL}/admin/blog/${id}`,
      DELETE: (id: number) => `${config.BASE_URL}/admin/blog/${id}`,
      UPLOAD_IMAGE: `${config.BASE_URL}/admin/blog/upload-image`,
      UPDATE_STATUS: (id: number) => `${config.BASE_URL}/admin/blog/${id}/status`,
      DUPLICATE: (id: number) => `${config.BASE_URL}/admin/blog/${id}/duplicate`,
    },
    
    // Nominations endpoints
    NOMINATIONS: {
      CATEGORIES: `${config.BASE_URL}/nominations/categories`,
      SUBMIT: `${config.BASE_URL}/nominations/submit`,
      USER_NOMINATIONS: `${config.BASE_URL}/nominations/user`,
      BY_ID: (id: number) => `${config.BASE_URL}/nominations/${id}`,
    },
    
    // Voting endpoints
    VOTING: {
      CATEGORIES: `${config.BASE_URL}/voting/categories`,
      NOMINEES: (categoryId: number) => `${config.BASE_URL}/voting/categories/${categoryId}/nominees`,
      NOMINEE_DETAILS: (nomineeId: number) => `${config.BASE_URL}/voting/nominees/${nomineeId}`,
      CAST_VOTE: `${config.BASE_URL}/voting/vote`,
      MY_VOTES: `${config.BASE_URL}/voting/my-votes`,
      CHECK_VOTE: (categoryId: number) => `${config.BASE_URL}/voting/categories/${categoryId}/check-vote`,
    },
    
    // Statistics endpoints
    STATISTICS: {
      ALL: `${config.BASE_URL}/statistics`,
    },
    
    // Partners endpoints
    PARTNERS: {
      LIST: `${config.BASE_URL}/partners`,
    },
    
    // Testimonials endpoints
    TESTIMONIALS: {
      LIST: `${config.BASE_URL}/testimonials`,
    },
    
    // Newsletter endpoints
    NEWSLETTER: {
      SUBSCRIBE: `${config.BASE_URL}/newsletter/subscribe`,
    },
  },
  
  STORAGE: {
    BASE: config.STORAGE_URL,
    BLOG_IMAGES: `${config.STORAGE_URL}/blog-images`,
    WINNER_IMAGES: `${config.STORAGE_URL}/winner-images`,
    NOMINATION_FILES: `${config.STORAGE_URL}/nomination-files`,
    PARTNER_LOGOS: `${config.STORAGE_URL}/partner-logos`,
    TESTIMONIAL_IMAGES: `${config.STORAGE_URL}/testimonial-images`,
    
    // Helper function to get full URL for any storage path
    getUrl: (path: string) => {
      if (!path) return '';
      if (path.startsWith('http')) return path; // Already a full URL
      // Remove leading slash if present
      const cleanPath = path.startsWith('/') ? path.substring(1) : path;
      return `${config.STORAGE_URL}/${cleanPath}`;
    },
  },
  
  APP: {
    BASE: config.APP_URL,
  },
};

// Export config for debugging or direct access
export const CONFIG = config;

export default URLS;

